import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import WebFont from 'webfontloader';
var options = {
  "google": {
    "families": ["Open+Sans:400,600,700&display=swap"]
  }
};
WebFont.load(options);